export default __webpack_public_path__ + "static/media/address.fc790948.svg";